import { useEffect } from 'react';
import { useTrackingCode } from 'react-hubspot-tracking-code-hook';
import { useLocation } from 'react-router-dom';

export function useNotifyHubSpotOnPageChange() {
  const location = useLocation();
  const { setPathPageView, setTrackPageView } = useTrackingCode();
  useEffect(() => {
    try {
      setPathPageView(location.pathname);
      setTrackPageView();
    } catch (error) {
      console.error(`Error sending page view tracking event to HubSpot for page ${location.pathname}`, error);
    }
  }, [location.pathname]);
}
